import { Column } from '~components/table-view';
import { linkCellRender } from '~components/table-view/columnRenderers';

/**
 * Creates column configurations for the clients with budgets table
 *
 * @param onClientClick - Callback function when a client name is clicked
 * @returns Array of column configurations for the table
 */
const columnsFactory = (onClientClick: (clientId: number) => void): Column[] => [
  {
    id: 'full_name',
    header: 'Client Name',
    type: 'text',
    // Fallback keeps the cell clickable when a client has no name — linkCellRender skips falsy values
    deriveValue: (row) => row.full_name || `Client #${row.id}`,
    renderReadOnly: linkCellRender((row) => onClientClick(row.id)),
  },
  {
    id: 'budget_count',
    header: 'Budgets',
    type: 'text',
    deriveValue: (row) => row.budgets?.length ?? 0,
  },
];

export default columnsFactory;
